module.exports = __webpack_public_path__ + "static/media/MOSIS SNUG World 2021.204a56cb.pdf";